import { render } from "./FundCard.vue?vue&type=template&id=51519caa&ts=true"
import script from "./FundCard.vue?vue&type=script&lang=ts"
export * from "./FundCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__